'use strict';

var _ = require('lodash');
var GridRemoveSortButtonController = function GridRemoveSortButtonController($scope) {
  var gridPanel = $scope.gridPanelScope;
  var columns = gridPanel.jqxGridSettings.columns;
  $scope.clearSortingIndicators = function () {
    _.forEach(columns, function (c) {
      c.sortingIndicator = undefined;
    });
  };
  $scope.removeSorting = function () {
    $scope.clearSortingIndicators();
    gridPanel.asyncGridApply('removesort');
  };
};
GridRemoveSortButtonController.$inject = ['$scope'];
module.exports = GridRemoveSortButtonController;